import React from 'react';
import moment from 'moment';
import '../styles/style.css'; 
interface Order {
  barNo: string;
  deliveryDate: string;
  deliveryStatus: string;
  ebOrderRef: string;
  fineness: string;
  orderDate: string;
  productName: string;
  tracking: string;
  weight: string;
  color: string;
  ebInvoiceRef: string;
  gstInvoiceRef: string;
}

interface PhysicalOrdersProps {
  orders: Order[];
  downloadDeliveryInvoice: (invoiceId: string) => void;
}

const PhysicalOrders: React.FC<PhysicalOrdersProps> = ({
  orders,
  downloadDeliveryInvoice,
}) => {
  return (
    <div className='physical-orders-table-wrapper'>
      <div className='physical-orders-table-scroll'>
        <table className='physical-orders-table'>
          <colgroup>
            <col style={{ width: '13%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '9%'  }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '13%' }} />
            <col style={{ width: '14%' }} />
            <col style={{ width: '11%' }} />
            <col style={{ width: '10%' }} />
          </colgroup>

          <thead className='physical-orders-table__head'>
            <tr>
              <th>Certicard No.</th>
              <th>Product</th>
              <th className='right'>Weight</th>
              <th>Fineness</th>
              <th>Order Date</th>
              <th>Status</th>
              <th className='center'>Tracking</th>
              <th className='center'>Action</th>
            </tr>
          </thead>

          <tbody>
            {orders.length === 0 ? (
              <tr>
                <td colSpan={8} className='physical-orders-table__empty'>
                  <div className='physical-orders-table__empty-icon'></div>
                  <div className='physical-orders-table__empty-text'>
                    No physical delivery orders available
                  </div>
                </td>
              </tr>
            ) : (
              orders.map((order, index) => (
                <tr
                  key={order.ebOrderRef || order.barNo || index}
                  className='physical-orders-table__row'
                >
                  {/* Certicard No */}
                  <td className='physical-orders-table__cell'>
                    <span className='physical-orders-table__order-id'>
                      {order.barNo || '—'}
                    </span>
                  </td>

                  {/* Product */}
                  <td className='physical-orders-table__cell'>
                    <span className='physical-orders-table__product'>
                      {order.productName}
                    </span>
                  </td>

                  {/* Weight */}
                  <td className='physical-orders-table__cell right'>
                    <span className='physical-orders-table__amount'>
                      {order.weight ? `${order.weight} g` : '—'}
                    </span>
                  </td>

                  {/* Fineness */}
                  <td className='physical-orders-table__cell'>
                    <span className='physical-orders-table__fineness'>
                      {order.fineness || '—'}
                    </span>
                  </td>

                  {/* Order Date */}
                  <td className='physical-orders-table__cell'>
                    <div className='physical-orders-table__date'>
                      {moment(order.orderDate).format('DD MMM YYYY')}
                    </div>
                    <div className='physical-orders-table__time'>
                      {moment(order.orderDate).format('hh:mm A')}
                    </div>
                  </td>

                  {/* Status */}
                  <td className='physical-orders-table__cell'>
                    <span
                      className='physical-orders-table__badge'
                      style={{
                        background: order.color ? `${order.color}18` : '#F1F2F4',
                        color: order.color || '#5C6470',
                      }}
                    >
                      {order.deliveryStatus || '—'}
                    </span>
                  </td>

                  {/* Tracking */}
                  <td className='physical-orders-table__cell center'>
                    {order.tracking ? (
                      <a
                        className='physical-orders-table__track-btn'
                        href={order.tracking}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <svg
                          className='physical-orders-table__track-icon'
                          viewBox='0 0 12 12'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M3 9 L9 3 M9 3 H4 M9 3 V8'
                            stroke='currentColor'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>
                        Track
                      </a>
                    ) : (
                      <span style={{ color: '#9CA3AF', fontSize: '13px' }}>—</span>
                    )}
                  </td>

                  {/* Action */}
                  <td className='physical-orders-table__cell center'>
                    <button
                      className='physical-orders-table__view-btn'
                      onClick={() => downloadDeliveryInvoice(order.gstInvoiceRef)}
                      title='Download Invoice'
                    >
                      <svg
                        width='12' height='12'
                        viewBox='0 0 24 24' fill='none'
                        stroke='currentColor' strokeWidth='2'
                        strokeLinecap='round' strokeLinejoin='round'
                      >
                        <path d='M5 12v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6' />
                        <path d='M12 3v12m0 0l4-4m-4 4l-4-4' />
                      </svg>
                      Invoice
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PhysicalOrders;